import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4ciczg6knl: FaireBrandEntity = {
  token: "b_4ciczg6knl",
  type: "brand",
  name: "Lanikai  Bath and Body",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb1cefaa60ab9e8ce426b7fa5ff99bc3c8ffa72f390d30d2f4cd633331a42a3d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/aa8de73a959c0a6519b076b417a638132de73929ed5603ed6726347ec99f66ba.png",
  logoUrl:
    "https://cdn.faire.com/fastly/eb1cefaa60ab9e8ce426b7fa5ff99bc3c8ffa72f390d30d2f4cd633331a42a3d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aa8de73a959c0a6519b076b417a638132de73929ed5603ed6726347ec99f66ba.png",
  location: "Kailua, HI, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 45,
  isInsider: false,
  description:
    "At Lanikai Bath and Body, our commitment to quality is unwavering; we carefully select only the finest ingredients our islands offer. Our ingredients include the rejuvenating properties of botanical extracts like papaya, Pacific sea kelp, and calendula, as well as the deeply nourishing benefits of natural oils including Macadamia, Kukui Nut, Jojoba, Avocado, and Vitamin E.\n\nLanikai Bath and Body's foundational scents are based on the fragrances of the Hawaiian islands, long known for its intoxicating aromas (aromatherapy could have been invented here). Our signature fragrances are exclusive to Lanikai Bath and Body and are true to Hawai`i's fruits and flowers.\n\nAt Lanikai Bath and Body, we take pride in the art of small-batch production, crafting each product with care to ensure it’s as fresh and invigorating as the tropical breezes of Hawai‘i. Since our items are made to order, please allow 11-14 days for production. We typically ship within 10 business days to deliver the freshest quality straight to your door.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:23.305Z",
    importedBy: "entity-db-cli",
  },
};
